interface BadgeProps {
  label: string;
}

export const Badge = ({ label }: BadgeProps) => (
  <div className="rounded-full border border-[#506CF0]/20 bg-[#506CF0]/10 px-4 py-1.5 text-sm text-[#506CF0]">
    {label}
  </div>
);
